export default (state = [], action) => {
  switch (action.type) {
      case 'SET_REPLY_TYPE_ENUM':
          return action.payload
      default:
          return state;
  }
};
